import React from 'react';
import { Grid, TextField } from '@mui/material';
import { CampoTextoMascarado, paraValorMascarado } from '../../campo-texto-mascarado/CampoTextoMascarado';
import { ICampoIndiceProps } from './ICampoIndiceProps';

export const CampoTexto: React.FC<ICampoIndiceProps> = ({ indice, valor, disabled, onChange, onEnterKeyDown }) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onEnterKeyDown?.();
            e.preventDefault();
        }
    };

    const temMascara = indice.opcoes !== undefined && indice.opcoes !== null && indice.opcoes !== '';

    return (
        <Grid item xs={12} sm={12} md={6} key={indice.idIndice}>
            {temMascara ? (
                <CampoTextoMascarado
                    fullWidth
                    mask={indice.opcoes as string}
                    label={indice.nomeIndice}
                    placeholder={`Digite o(a) ${indice.nomeIndice}`}
                    disabled={disabled}
                    value={paraValorMascarado(valor ?? '', indice.opcoes as string)}
                    onChange={(_, valorCru) => onChange(valorCru)}
                    onKeyDown={handleKeyDown}
                />
            ) : (
                <TextField
                    key={'TextField-' + indice.idIndice}
                    fullWidth
                    label={indice.nomeIndice}
                    placeholder={`Digite o(a) ${indice.nomeIndice}`}
                    disabled={disabled}
                    value={valor ?? ''}
                    onKeyDown={handleKeyDown}
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                    onChange={(event) => onChange(event.target.value)}
                />
            )}
        </Grid>
    );
};
